import { useEffect } from "react";

import { presentScriptureReference, sendMessageToHost } from "~/utils/events";

const SCRIPTURE_LINK_EVENT_NAME = "bp:scripture_link";
const EXTERNAL_LINK_EVENT_NAME = "bp:external_link";

function handleScriptureLink(e: Event) {
  const { detail } = e as CustomEvent<{ reference: string }>;
  presentScriptureReference(detail.reference);
}

function handleExternalLinkClick(e: Event) {
  const { detail } = e as CustomEvent<{ href: string }>;
  sendMessageToHost({
    navigation: {
      presentLink: {
        url: detail.href,
      },
    },
  });
}

/**
 * Handles (globally) events dispatched by bp-components.
 */
export function useBpComponentEvents() {
  useEffect(() => {
    document.addEventListener(SCRIPTURE_LINK_EVENT_NAME, handleScriptureLink);
    document.addEventListener(
      EXTERNAL_LINK_EVENT_NAME,
      handleExternalLinkClick,
    );

    return () => {
      document.removeEventListener(
        SCRIPTURE_LINK_EVENT_NAME,
        handleScriptureLink,
      );
      document.removeEventListener(
        EXTERNAL_LINK_EVENT_NAME,
        handleExternalLinkClick,
      );
    };
  }, []);
}
